// ¿Qué onboarding le falta a esta cuenta? Preguntado a la BASE, no al flag en memoria.
//
// El flag de `cuestionarioObligatorio` es un atajo: vive en memoria y lo prenden y apagan
// lecturas que pueden llegar tarde (ADR-2026-10-20-el-onboarding-no-rebota-con-una-lectura-vieja).
// Antes de sacar a alguien de donde está —el guardia de navegación, o el primer paso del
// onboarding que lo devolvería a la app— se confirma acá con una lectura nueva. Es una
// consulta chica y sólo corre en esos momentos, que son raros.
//
// "No se sabe" (sin sesión, sin empresa, error de red o de RLS) NO es "pendiente": quien
// llama no mueve a nadie. Es la misma regla que el rebote de `App`: una lectura fallida
// nunca saca a un cliente de donde está.

// Desde ADR-2026-10-31-onboarding-corto-para-la-prueba son dos (el cuestionario corto y el de
// marca) y la respuesta sale de la MISMA regla que usa el rebote de `App` (`onboardingQueSeDebe`).
//
import { supabase } from './supabase';
import { pagoConMarcaPendiente } from './pagoConMarcaPendiente';
import {
  COLUMNAS_DE_ONBOARDING,
  onboardingQueSeDebe,
  type FilaDeOnboarding,
  type OnboardingDebido,
} from './onboardingDebido';

/** `null` = no le falta ninguno. `recienPago`: ver `onboardingQueSeDebe`. */
export async function leerOnboardingEnLaBase(opts?: {
  recienPago?: boolean;
}): Promise<OnboardingDebido | 'no_se_sabe'> {
  try {
    const { data } = await supabase.auth.getSession();
    const userId = data.session?.user?.id;
    if (!userId) return 'no_se_sabe';
    // `.maybeSingle()` no tira: el error se mira a mano en las dos consultas.
    const { data: perfil, error: errorPerfil } = await supabase
      .from('profiles')
      .select('id_company')
      .eq('id', userId)
      .maybeSingle();
    const idCompany = (perfil as { id_company?: string | null } | null)?.id_company;
    if (errorPerfil || !idCompany) return 'no_se_sabe';
    const { data: empresa, error: errorEmpresa } = await supabase
      .from('company_profiles')
      .select(COLUMNAS_DE_ONBOARDING)
      .eq('id_company', idCompany)
      .maybeSingle();
    if (errorEmpresa || !empresa) return 'no_se_sabe';
    // Un pago recién hecho en esta pestaña sobrevive la recarga (`pagoConMarcaPendiente`).
    const recienPago = opts?.recienPago === true || pagoConMarcaPendiente(userId);
    return onboardingQueSeDebe(empresa as FilaDeOnboarding, userId, { recienPago });
  } catch {
    return 'no_se_sabe';
  }
}
